var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5C3.50054 1.5 1 4.00054 1 11.5C1 18.9995 3.50054 21.5 11 21.5C18.4995 21.5 21 18.9995 21 11.5",
    stroke: "#006770",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1388 3.17971C18.0653 2.22944 16.4253 2.3289 15.475 3.40242C15.475 3.40242 10.7518 8.73755 9.11393 10.5894C7.47393 12.4403 8.67609 14.997 8.67609 14.997C8.67609 14.997 11.3831 15.8543 12.9983 14.0294C14.6145 12.2046 19.3615 6.8435 19.3615 6.8435C20.3118 5.76998 20.2112 4.12998 19.1388 3.17971Z",
    stroke: "#006770",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2527 4.79785L18.1392 8.23893",
    stroke: "#006770",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c6ba1b513fb3328100d539938e4323b3.svg";
export { ForwardRef as ReactComponent };